// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchForm_wrapper__vKs7G","input":"SearchForm_input__aln_q","button":"SearchForm_button__D3aOm","icon":"SearchForm_icon__6I4GC"};